import React from 'react';
// template components
import InformationalModule from '@nmx/template/dist/componentLibrary/modules/InformationalModule';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// icons
import CaratRight from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/CaratRight';
// images
import financialPlanningImageDesktopWebp from './images/inclusive-workplace-desktop.webp';
import financialPlanningImageMobileWebp from './images/inclusive-workplace-mobile.webp';
// styles
import { LinkStyled } from './styles';

export default () => {
  return (
    <InformationalModule
      // configs
      sectionId='who-we-are-financial-planning-4'
      themeType='lightTheme'
      backgroundVariant='lightB'
      moduleName='financial-planning-module'
      moduleVariation='A'
      reverseContent={false}
      // content
      subHeadingText={<>We believe <WidowBlock>in inclusion.</WidowBlock></>}
      // column content
      columnContentA={(
        <>
          <Typography nextElement='link'>
            We know that the collective ideas, opinions, and creativity of a&nbsp;
            <Link
              id='who-we-are-financial-planning-4-careers-link'
              variant='primaryDeemphasize'
              linkUrl='/careers/'>
              diverse workforce
            </Link>
            &nbsp;is necessary to deliver the&nbsp;
            <Link
              id='who-we-are-financial-planning-4-innovation-link'
              variant='primaryDeemphasize'
              linkUrl='https://innovation.northwesternmutual.com/?utm_source=website&utm_medium=link&utm_campaign=who-we-are&utm_term=our-culture-of-innovation&utm_content=na'
              isOutgoingLink>
              innovative financial solutions
            </Link>
            &nbsp;our clients need. It&#39;s why we&#39;re committed to creating a singular culture of inclusion and respect. But we don&#39;t stop there. We&#39;re also dedicated to supporting and promoting inclusion within our communities and the businesses and suppliers we partner with.
          </Typography>
          <LinkStyled
            id='who-we-are-see-more-diversity'
            variant='buttonLinkTertiary'
            endAdornment={CaratRight}
            endAdornmentStylesReset
            linkUrl='/who-we-are/sustainability-impact/culture/'>
            See more about our commitment to diversity and inclusion
          </LinkStyled>
        </>
      )}
      // image props
      imageAltText='A sharply dressed financial advisor.'
      imageSrcDefault={financialPlanningImageDesktopWebp}
      imageSrcMobile={financialPlanningImageMobileWebp}
    />
  );
};
